export enum FeeTypeEnum {
  Service = 0,
  Translation = 1,
  Expense = 2
}

export enum FeeTypeNameEnum {
  Service = "Service",
  Translation = "Translation",
  Expense = "Expense"
}

export enum FeeSheetModalType {
  Add = "Add",
  Update = "Update"
}

export enum FeeSheetModalFor {
  Client = "Client",
  Agent = "Agent"
}